import React, { FC, useMemo } from 'react';

import { ScanCrawlStateHelper } from '../../../../helpers/ScanCrawlStateHelper';
import { SCAN_STATE } from '../../../../interfaces/ScanState';
import { StatusIcon } from '../../../status-icon/StatusIcon';

import { STATUS_DISPLAY_MAPPING } from './StatusFormatter.const';

import './StatusFormatter.scss';

interface IStatusFormatterProps {
	scanState: SCAN_STATE;
}

const StatusFormatter: FC<IStatusFormatterProps> = ({ scanState }: IStatusFormatterProps) => {
	const cellText: string = useMemo(
		() => STATUS_DISPLAY_MAPPING[scanState] ?? scanState,
		[scanState]
	);
	if (!scanState) {
		return <>N/A</>;
	}
	const isCanceled = ScanCrawlStateHelper.isCanceled(scanState);
	if (isCanceled) {
		return <>N/A</>;
	}

	return (
		<div className="status-cell">
			<StatusIcon state={scanState} isScan={true} />
			<div className="status-text">{cellText}</div>
		</div>
	);
};

export { StatusFormatter };
